export const SET_SIGNUP_INFO = 'SET_SIGNUP_INFO';
